import React, { useState } from 'react';
import classNames from 'classnames';
import { clearHtml } from "fantastic/lib/sanitizer";

const Result = ({ value, children }) => {

  const classes = classNames("s-copywriter-editor", {
    "ink": !children,
    "s-copywriter-editor_empty": !!children
  });

  if (children) return <div className={classes}>{children}</div>;

  return (
    <div className={classes}>
      <div className="mail" dangerouslySetInnerHTML={{ __html: clearHtml(value) }} />
    </div>
  );
};

export default Result;
